/**
 * @format
 * @param {string} url
 * @returns {Object}
 */

export function param2Obj(url): any {
	const search = url ? decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ') : '';
	if (!search) {
		return {};
	}
	const obj = {};
	const searchArr = search.split('&');
	searchArr.forEach((v) => {
		const index = v.indexOf('=');
		if (index !== -1) {
			const name = v.substring(0, index);
			const val = v.substring(index + 1, v.length);
			obj[name] = val;
		}
	});
	return obj;
}

/**
 * 将对象添加当作参数拼接到URL上面
 * @param baseUrl 需要拼接的url
 * @param obj 参数对象
 * @returns {string} 拼接后的对象
 * 例子:
 * ` let obj = {a: '3', b: '4'}
 *  setObjToUrlParams('www.baidu.com', obj)
 *  ==>www.baidu.com?a=3&b=4
 * `
 */
export function setObjToUrlParams(baseUrl: string, obj: object): string {
	let parameters = '';
	let url = '';
	for (const key in obj) {
		parameters += `${key}=${encodeURIComponent(obj[key])}&`;
	}
	parameters = parameters.replace(/&$/, '');
	if (/\?$/.test(baseUrl)) {
		url = baseUrl + parameters;
	} else {
		url = baseUrl.replace(/\/?$/, '?') + parameters;
	}
	return url;
}

/**
 * 将路径中重复的正斜杆替换成单个斜杆隔开的字符串
 * @param path 要处理的路径
 * @returns {string} 将/去重后的结果
 */
export const uniqueSlash = (path: string) => path.replace(/([^:])\/{2,}/g, '$1/');

/**
 * /*
 * 格式化参数
 *
 * @format
 */

export function formatParams(data = {}) {
	const arr: any[] = [];
	for (const name in data) {
		arr.push(`${encodeURIComponent(name)}=${encodeURIComponent(data[name])}`);
	}
	return arr.join('&');
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
	url = url == null ? window.location.href : url;
	const search = url.substring(url.lastIndexOf('?') + 1);
	const obj = {};
	const reg = /([^?&=]+)=([^?&=]*)/g;
	search.replace(reg, (rs, $1, $2) => {
		const name = decodeURIComponent($1);
		let val = decodeURIComponent($2);
		val = String(val);
		obj[name] = val;
		return rs;
	});
	return obj;
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
	let result = '';
	for (const propName of Object.keys(params)) {
		const value = params[propName];
		const part = `${encodeURIComponent(propName)}=`;
		if (value !== null && value !== '' && typeof value !== 'undefined') {
			if (typeof value === 'object') {
				for (const key of Object.keys(value)) {
					if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
						const params = `${propName}[${key}]`;
						const subPart = `${encodeURIComponent(params)}=`;
						result += `${subPart + encodeURIComponent(value[key])}&`;
					}
				}
			} else {
				result += `${part + encodeURIComponent(value)}&`;
			}
		}
	}
	return result;
}

/**
 * 对象转queryString
 * @param obj 对象
 */
export function objectToQueryString(obj: any) {
	return Object.entries(obj)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`)
		.join('&');
}

/**
 * queryString 转 对象
 * @param queryString queryString a=1&b=2
 */
export function queryStringToObject(queryString) {
	const obj = {};
	const arr = queryString.split('&');
	for (let i = 0; i < arr.length; i++) {
		const temp = arr[i].split('=');
		obj[temp[0]] = temp[1];
	}
	return obj;
}
